import { render, staticRenderFns } from "./RedesignTeamList.vue?vue&type=template&id=129e80e6&scoped=true"
import script from "./RedesignTeamList.vue?vue&type=script&lang=js"
export * from "./RedesignTeamList.vue?vue&type=script&lang=js"
import style0 from "./RedesignTeamList.vue?vue&type=style&index=0&id=129e80e6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./RedesignTeamList.vue?vue&type=style&index=1&id=129e80e6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129e80e6",
  null
  
)

export default component.exports